/* import __COLOCATED_TEMPLATE__ from './tag-chooser-row.hbs'; */
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
export default SelectKitRowComponent.extend({
  classNames: ["tag-chooser-row"]
});